function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React, { Component } from 'react';
import VirtualList from 'react-tiny-virtual-list';
import classNames from 'classnames';
import { emptyFn, getMonth, getWeeksInMonth, animate } from '../utils';
import Month from '../Month';
var styles = {
  "root": "Cal__MonthList__root",
  "scrolling": "Cal__MonthList__scrolling"
};
import { isValid } from 'date-fns';
var AVERAGE_ROWS_PER_MONTH = 5;

var MonthList = /*#__PURE__*/function (_Component) {
  _inheritsLoose(MonthList, _Component);

  function MonthList() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      scrollTop: _this.getDateOffset(_this.props.scrollDate)
    });

    _defineProperty(_assertThisInitialized(_this), "cache", {});

    _defineProperty(_assertThisInitialized(_this), "memoize", function (param) {
      if (!this.cache[param]) {
        var weekStartsOn = this.props.locale.weekStartsOn;

        var _param$split = param.split(':'),
            year = _param$split[0],
            month = _param$split[1];

        var result = getMonth(year, month, weekStartsOn);
        this.cache[param] = result;
      }

      return this.cache[param];
    });

    _defineProperty(_assertThisInitialized(_this), "monthHeights", []);

    _defineProperty(_assertThisInitialized(_this), "_getRef", function (instance) {
      _this.VirtualList = instance;
    });

    _defineProperty(_assertThisInitialized(_this), "getMonthHeight", function (index) {
      if (!_this.monthHeights[index]) {
        var _this$props = _this.props,
            weekStartsOn = _this$props.locale.weekStartsOn,
            months = _this$props.months,
            rowHeight = _this$props.rowHeight;
        var _months$index = months[index],
            month = _months$index.month,
            year = _months$index.year;

        var _this$memoize = _this.memoize(year + ":" + month),
            rows = _this$memoize.rows;

        var weeks = getWeeksInMonth(month, year, weekStartsOn);
        var height = weeks * rowHeight;
        _this.monthHeights[index] = height + (rows[rows.length - 1].length === 7 ? 49 : 97);
      }

      return _this.monthHeights[index];
    });

    _defineProperty(_assertThisInitialized(_this), "scrollToDate", function (date, offset) {
      var _this2;

      if (offset === void 0) {
        offset = 0;
      }

      var offsetTop = _this.getDateOffset(date);

      for (var _len2 = arguments.length, rest = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        rest[_key2 - 2] = arguments[_key2];
      }

      (_this2 = _this).scrollTo.apply(_this2, [offsetTop + offset].concat(rest));
    });

    _defineProperty(_assertThisInitialized(_this), "scrollTo", function (scrollTop, shouldAnimate, onScrollEnd) {
      if (scrollTop === void 0) {
        scrollTop = 0;
      }

      if (shouldAnimate === void 0) {
        shouldAnimate = false;
      }

      if (onScrollEnd === void 0) {
        onScrollEnd = emptyFn;
      }

      var onComplete = function onComplete() {
        return setTimeout(function () {
          _this.scrollEl.style.overflowY = 'auto';
          onScrollEnd();
        });
      }; // Interrupt iOS Momentum scroll


      _this.scrollEl.style.overflowY = 'hidden';

      if (shouldAnimate) {
        /* eslint-disable sort-keys */
        animate({
          fromValue: _this.scrollEl.scrollTop,
          toValue: scrollTop,
          onUpdate: function onUpdate(scrollTop, callback) {
            return _this.setState({
              scrollTop: scrollTop
            }, callback);
          },
          onComplete: onComplete
        });
      } else {
        window.requestAnimationFrame(function () {
          _this.scrollEl.scrollTop = scrollTop;
          onComplete();
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderMonth", function (_ref) {
      var index = _ref.index,
          style = _ref.style;
      var _this$props2 = _this.props,
          DayComponent = _this$props2.DayComponent,
          disabledDates = _this$props2.disabledDates,
          disabledDays = _this$props2.disabledDays,
          locale = _this$props2.locale,
          maxDate = _this$props2.maxDate,
          minDate = _this$props2.minDate,
          months = _this$props2.months,
          passThrough = _this$props2.passThrough,
          rowHeight = _this$props2.rowHeight,
          selected = _this$props2.selected,
          showOverlay = _this$props2.showOverlay,
          theme = _this$props2.theme,
          today = _this$props2.today;
      var _months$index2 = months[index],
          month = _months$index2.month,
          year = _months$index2.year;
      var key = year + ":" + month;

      var _this$memoize2 = _this.memoize(key),
          date = _this$memoize2.date,
          rows = _this$memoize2.rows;

      return /*#__PURE__*/React.createElement(Month, _extends({
        key: key,
        selected: selected,
        DayComponent: DayComponent,
        monthDate: date,
        disabledDates: disabledDates,
        disabledDays: disabledDays,
        maxDate: maxDate,
        minDate: minDate,
        rows: rows,
        rowHeight: rowHeight,
        isScrolling: false,
        showOverlay: showOverlay,
        today: today,
        theme: theme,
        style: _extends({}, style),
        locale: locale,
        passThrough: passThrough
      }, passThrough.Month));
    });

    return _this;
  }

  var _proto = MonthList.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.scrollEl = this.VirtualList.rootNode;
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(_ref2) {
    var scrollDate = _ref2.scrollDate;

    if (scrollDate !== this.props.scrollDate) {
      this.setState({
        scrollTop: this.getDateOffset(scrollDate)
      });
    }
  };

  _proto.getDateOffset = function getDateOffset() {
    var _this$props3 = this.props,
        focusOnDate = _this$props3.focusOnDate,
        selected = _this$props3.selected;
    if (focusOnDate === 'return' && !isValid(new Date(selected.start)) && !isValid(new Date(selected.end))) return 0;
    var date = new Date();
    var today_month = new Date().getMonth() + 1;
    var today_year = new Date().getFullYear();
    var dep_date;

    if (selected.start) {
      var dateToScroll = focusOnDate === 'depart' ? selected.start : selected.end;
      dep_date = new Date(dateToScroll).toLocaleDateString('en-US', {
        timeZone: 'UTC'
      });
    }

    var pixelToScroll = 0;
    var month_iterate = (new Date(dep_date).getFullYear() - date.getFullYear()) * 12;
    month_iterate -= date.getMonth();
    month_iterate += new Date(dep_date).getMonth();
    month_iterate = month_iterate <= 0 ? 0 : month_iterate;
    var yearIterate = today_year;

    for (var i = 1; i <= month_iterate; i++) {
      var j = i % 13;

      if (new Date(yearIterate, today_month - 1 + j, 0).getDate() === 31) {
        if (new Date(yearIterate, today_month - 2 + j, 1).getDay() <= 4) {
          pixelToScroll += 289;
        } else {
          pixelToScroll += 337;
        }
      } else if (new Date(yearIterate, today_month - 1 + j, 0).getDate() === 30) {
        if (new Date(yearIterate, today_month - 2 + j, 1).getDay() === 6) {
          pixelToScroll += 337;
        } else {
          pixelToScroll += 289;
        }
      } else {
        if (new Date(yearIterate, today_month - 2 + j, 1).getDay() === 0 && new Date(yearIterate, today_month - 1 + j, 0).getDate() === 28) {
          pixelToScroll += 241;
        } else {
          pixelToScroll += 289;
        }
      }

      yearIterate = j === 12 ? yearIterate + 1 : yearIterate;
    }

    var rowsToScrollReturnPixels = 0;
    var return3rowsMinus = 0;

    if (focusOnDate === 'return') {
      var return_date = parseInt(String(selected.end).split('-')[2]);
      var firstDayOn = new Date(new Date(selected.end).getFullYear(), new Date(selected.end).getMonth(), 1).getDay();
      var rowsToScroll = return_date - (6 - firstDayOn + 1) <= 0 ? 0 : (return_date - (6 - firstDayOn + 1)) % 7 === 0 ? parseInt((return_date - (6 - firstDayOn + 1)) / 7) : parseInt((return_date - (6 - firstDayOn + 1)) / 7) + 1;
      rowsToScrollReturnPixels = rowsToScroll * 48 + 33;
      return3rowsMinus = rowsToScroll >= 4 ? 48 * 4 : rowsToScroll === 3 ? 48 * 3 + 33 : 48 * 3 + 50;
    }

    return pixelToScroll + rowsToScrollReturnPixels - return3rowsMinus;
  };

  _proto.render = function render() {
    var _classNames;

    var _this$props4 = this.props,
        height = _this$props4.height,
        isScrolling = _this$props4.isScrolling,
        onScroll = _this$props4.onScroll,
        overscanMonthCount = _this$props4.overscanMonthCount,
        months = _this$props4.months,
        rowHeight = _this$props4.rowHeight,
        width = _this$props4.width;
    var scrollTop = this.state.scrollTop;
    return /*#__PURE__*/React.createElement(VirtualList, {
      ref: this._getRef,
      width: width,
      height: height,
      itemCount: months.length,
      itemSize: this.getMonthHeight,
      estimatedItemSize: rowHeight * AVERAGE_ROWS_PER_MONTH,
      renderItem: this.renderMonth,
      onScroll: onScroll,
      scrollOffset: scrollTop,
      className: classNames(styles.root, (_classNames = {}, _classNames[styles.scrolling] = isScrolling, _classNames)),
      style: {
        lineHeight: rowHeight + "px"
      },
      overscanCount: overscanMonthCount
    });
  };

  return MonthList;
}(Component);

export { MonthList as default };